// @flow
import * as types from '../types/followingTrip';
import * as tripTypes from '../types/trips';
import type { FOLLOWINGTRIP_ACTION_TYPE } from '../types/followingTrip';
import type { TRIP_SELECTED_TYPE } from '../types/trips';

export type FollowingTripState = boolean;

const followingTrip = (
  state: FollowingTripState = true,
  action: FOLLOWINGTRIP_ACTION_TYPE | TRIP_SELECTED_TYPE,
): FollowingTripState => {
  switch (action.type) {
    case types.FOLLOWING_TRIP_FIXED:
    case tripTypes.TRIP_SELECTED: {
      return true;
    }

    case types.FOLLOWING_TRIP_RELEASED: {
      return false;
    }

    default:
      return state;
  }
};

export default followingTrip;

export const isFollowingTrip = (state: FollowingTripState): boolean => state;



// WEBPACK FOOTER //
// ./src/scripts/reducers/followingTrip.js